module.exports = "<button\n  [disabled]=\"disabled\"\n  [type]=\"type\"\n  [class.primary]=\"style === 'primary'\"\n  [class.secondary]=\"style === 'secondary'\"\n  (click)=\"onClick.emit($event)\">\n  <span>{{ label }}</span>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/app-button/app-button.component.html
// module id = 1212
// module chunks = 0